import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  switchLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
    },
  },
}));

export { useStyles };
